export const cellTypes = {
  INQUIRY: 'INQUIRY',
  FILLED: 'FILLED',
  EMPTY: 'EMPTY',
  CORNER: 'CORNER',
  IMAGINARY: 'IMAGINARY',
  IMAGINARY_REVERSE: 'IMAGINARY_REVERSE',
  BINOCULAR: 'BINOCULAR',
}
export const cornerTypes = {
  UP: 'UP',
  DOWN: 'DOWN',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  EMPTY: 'EMPTY',
}
